export default {
  surveyResponse(state) {
    return state.response
  },
  isSerialized(state) {
    return state.isSerialized
  },
}
